export const formatWeekdayTime = (daytime: string[]): string[] => {
  const dayTimesStringArray: string[] = [];

  if (daytime.length === 0) {
    return dayTimesStringArray;
  }

  let startHour = Number(daytime[0].split(":")[0]);
  let endHour = startHour;

  for (let i = 1; i < daytime.length; i++) {
    const currentHour = Number(daytime[i].split(":")[0]);

    if (currentHour !== endHour + 1) {
      if (startHour !== endHour) {
        dayTimesStringArray.push(`${startHour}:00 - ${endHour}:00`);
      } else {
        dayTimesStringArray.push(`${startHour}:00`);
      }

      startHour = currentHour;
    }

    endHour = currentHour;
  }
  startHour !== endHour
    ? dayTimesStringArray.push(`${startHour}:00 - ${endHour}:00`)
    : dayTimesStringArray.push(`${startHour}:00`);

  return dayTimesStringArray;
};
